import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    MyProfileInfoCard,
    MyProfileLoadingCard,
    MyProfileSecurityCard,
    MyProfileSignatureCard,
} from './components/my-profile/components';
import { useMyProfile } from './components/my-profile/hooks';

export const MyProfileScreen = () => {
    const dispatch = useDispatch();
    const { id, token, name, email, photoUrl, available = true, active = true, role = 'USER' } = useSelector((state) => state.auth);

    const {
        isLoading,
        isSavingPhone,
        isSavingSignature,
        isSavingAvatar,
        isChangingPassword,
        phone,
        isAvailable,
        avatarUrl,
        currentPassword,
        newPassword,
        confirmPassword,
        avatarInputRef,
        signatureEditorRef,
        passwordRules,
        setPhone,
        setSignatureHtml,
        setCurrentPassword,
        setNewPassword,
        setConfirmPassword,
        handleAvailabilityChange,
        handlePhoneSave,
        handleSignatureSave,
        handleAvatarSelected,
        handleChangePassword,
        runEditorCommand,
    } = useMyProfile({
        id,
        token,
        name,
        initialPhotoUrl: photoUrl,
        initialAvailable: available,
        dispatch,
    });

    return (
        <div className="row">
            <div className="col-12 col-xl-9 col-xxl-8 mx-auto">
                <div className="mb-3">
                    <h5 className="fw-bold mb-1">Mi perfil</h5>
                    <p className="text-muted mb-0">Gestiona tu información personal, seguridad y firma de tickets.</p>
                </div>

                {isLoading ? (
                    <MyProfileLoadingCard />
                ) : (
                    <div className="d-flex flex-column gap-3">
                        <MyProfileInfoCard
                            name={name}
                            email={email}
                            role={role}
                            active={active}
                            avatarUrl={avatarUrl}
                            isSavingAvatar={isSavingAvatar}
                            avatarInputRef={avatarInputRef}
                            onAvatarSelected={handleAvatarSelected}
                            isAvailable={isAvailable}
                            onAvailabilityChange={handleAvailabilityChange}
                            phone={phone}
                            onPhoneChange={setPhone}
                            onPhoneSave={handlePhoneSave}
                            isSavingPhone={isSavingPhone}
                        />

                        <MyProfileSecurityCard
                            currentPassword={currentPassword}
                            newPassword={newPassword}
                            confirmPassword={confirmPassword}
                            onCurrentPasswordChange={setCurrentPassword}
                            onNewPasswordChange={setNewPassword}
                            onConfirmPasswordChange={setConfirmPassword}
                            passwordRules={passwordRules}
                            onSubmit={handleChangePassword}
                            isChangingPassword={isChangingPassword}
                        />

                        <MyProfileSignatureCard
                            signatureEditorRef={signatureEditorRef}
                            onEditorInput={(event) => setSignatureHtml(event.currentTarget.innerHTML || '')}
                            onEditorCommand={runEditorCommand}
                            onSave={handleSignatureSave}
                            isSavingSignature={isSavingSignature}
                        />
                    </div>
                )}
            </div>

            <ToastContainer
                position="top-right"
                autoClose={2500}
                hideProgressBar
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
                theme="light"
            />
        </div>
    );
};
